/**
 * Todos los pesos usados por scoringEngine.ts viven aqui para poder
 * ajustarlos sin tocar la logica de calculo ni los componentes de UI.
 * Cada grupo de pesos debe sumar 1.
 */

export const READINESS_WEIGHTS = {
  recovery: 0.45,
  sleep: 0.3,
  activityBalance: 0.15,
  nutrition: 0.1,
};

export const SLEEP_SCORE_WEIGHTS = {
  duration: 0.3,
  efficiency: 0.2,
  deepSleep: 0.2,
  remSleep: 0.15,
  latency: 0.1,
  awakenings: 0.05,
};

export const RECOVERY_SCORE_WEIGHTS = {
  hrv: 0.35,
  restingHeartRate: 0.25,
  respiratoryRate: 0.15,
  spo2: 0.15,
  temperatureStability: 0.1,
};

export const ACTIVITY_SCORE_WEIGHTS = {
  steps: 0.3,
  exerciseMinutes: 0.3,
  weeklyLoadBalance: 0.25,
  recoveryAlignment: 0.15,
};

export const NUTRITION_SCORE_WEIGHTS = {
  calorieAdherence: 0.3,
  protein: 0.3,
  macroBalance: 0.2,
  fiber: 0.1,
  sugarSodiumControl: 0.1,
};

/**
 * Rangos generales razonables, usados unicamente como respaldo cuando aun
 * no existe suficiente baseline personal (por ejemplo, en los primeros dias
 * de uso de la app).
 */
export const GENERAL_TARGETS = {
  sleepDurationMinutes: 450,
  sleepEfficiencyPercent: 85,
  sleepLatencyMinutes: 15,
  stepsGoal: 9000,
  exerciseMinutesGoal: 30,
  proteinPerKg: 1.6,
  proteinTargetGramsFallback: 130,
  fiberTargetGrams: 28,
  sugarLimitGrams: 50,
  sodiumLimitMg: 2300,
  respiratoryRateRange: [12, 18] as [number, number],
  spo2Min: 95,
  weeklyExerciseMinutesRange: [150, 300] as [number, number],
};
